module.exports = __webpack_public_path__ + "static/media/8.1993723d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/悬浮窗/8.png
// module id = 1304
// module chunks = 0